import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import { BUSINESS } from "@/data/content";
import Logo from "@/components/Logo";

const QUICK_LINKS = [
  { label: "Auto Detailing", href: "/#pricing", testid: "footer-link-detailing" },
  { label: "Authority+", href: "/#authority-plus", testid: "footer-link-authority-plus" },
  { label: "Gallery", href: "/#gallery", testid: "footer-link-gallery" },
  { label: "FAQ", href: "/#faq", testid: "footer-link-faq" },
  { label: "Contact", href: "/#contact", testid: "footer-link-contact" },
];

export default function Footer() {
  return (
    <footer className="relative bg-[#050914] border-t border-white/10 pt-16 pb-8 px-5 lg:px-8">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <Logo size={48} />
            <div>
              <div className="font-display font-bold text-white">Authority Detailing Co.</div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-blue-400/80">
                Setting the Standard
              </div>
            </div>
          </div>
          <p className="text-sm text-white/60 leading-relaxed">
            Mobile auto detailing and trash bin cleaning serving Phoenix and the surrounding valley.
            Licensed &amp; Insured.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            {QUICK_LINKS.map((l) => (
              <li key={l.label}>
                <a
                  href={l.href}
                  className="text-white/70 hover:text-blue-400 transition-colors"
                  data-testid={l.testid}
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <Link
                to="/bin-cleaning"
                className="text-white/70 hover:text-blue-400 transition-colors"
                data-testid="footer-link-bin-cleaning"
              >
                Trash Bin Cleaning
              </Link>
            </li>
            <li>
              <Link
                to="/book"
                className="text-white/70 hover:text-blue-400 transition-colors"
                data-testid="footer-link-book"
              >
                Book Your Service
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-3">
              <Phone className="h-4 w-4 text-blue-400 mt-0.5" />
              <a href={`tel:${BUSINESS.phoneRaw}`} className="hover:text-white">
                {BUSINESS.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="h-4 w-4 text-blue-400 mt-0.5" />
              <a href={`mailto:${BUSINESS.email}`} className="hover:text-white break-all">
                {BUSINESS.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 text-blue-400 mt-0.5" />
              <span>{BUSINESS.area}</span>
            </li>
            <li className="flex items-start gap-3">
              <Clock className="h-4 w-4 text-blue-400 mt-0.5" />
              <span>{BUSINESS.hours}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
        <div>© {new Date().getFullYear()} Authority Detailing Co. All rights reserved.</div>
        <div className="font-mono uppercase tracking-[0.25em] text-[10px] text-white/30">
          Setting the Standard · Leading the Industry · Earning Your Trust
        </div>
      </div>
    </footer>
  );
}
